



import { Component, Vue } from "vue-property-decorator";
import NewsReleaseTep from "@/template/live/NewsRelease.vue";
@Component
export default class NewsRelease extends NewsReleaseTep {}
